import type { LinearMention } from "@productlane/lib/src/linear-mentions"
import { linearMentionFromLink } from "@productlane/lib/src/linear-mentions"

export interface LinearMentionSlot {
	container: HTMLAnchorElement
	mention: LinearMention
}

// Empties each mention link so a badge can render inside it. The original text
// stays on the element, so a second pass (StrictMode, a re-render) finds it again.
export function claimLinearMentionSlots(
	root: HTMLElement,
): LinearMentionSlot[] {
	const slots: LinearMentionSlot[] = []
	for (const anchor of root.querySelectorAll<HTMLAnchorElement>("a[href]")) {
		const claimed = anchor.dataset.linearMention !== undefined
		if (!claimed && anchor.children.length > 0) continue

		const text = anchor.dataset.linearMentionText ?? anchor.textContent ?? ""
		const mention = linearMentionFromLink({
			href: anchor.getAttribute("href") ?? "",
			text,
		})
		if (!mention) continue

		if (!claimed) {
			anchor.dataset.linearMentionText = text
			anchor.dataset.linearMention = mention.kind
			anchor.textContent = ""
		}
		slots.push({ container: anchor, mention })
	}
	return slots
}
